module.exports = __webpack_public_path__ + "img/seital.b9ba7348.png";